import type { ReactNode } from 'react';

interface LovemoSectionHeadingProps {
  eyebrow: string;
  title: ReactNode;
  desc?: ReactNode;
  align?: 'center' | 'left';
}

export default function LovemoSectionHeading({
  eyebrow,
  title,
  desc,
  align = 'center',
}: LovemoSectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`lovemo-reveal ${isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}`}>
      <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200/70 bg-secondary-50 px-3.5 py-1.5 font-label text-xs font-semibold text-secondary-700">
        <i className="ri-heart-3-line" aria-hidden="true" />
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p className={`mt-3 text-sm leading-relaxed text-foreground-700 md:text-base ${isCenter ? 'mx-auto' : ''}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}